"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendBuffer = exports.Qora = void 0;
var Base58_1 = require("./Base58");
var RIPEMD160_1 = require("./RIPEMD160");
var AppCrypt_1 = require("../AppCrypt");
var convert_1 = require("./convert");
var Qora = /** @class */ (function () {
    function Qora() {
    }
    Qora.generateAccountSeed = function (seed, nonce) {
        return __awaiter(this, void 0, void 0, function () {
            var nonceBytes, resultSeed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof seed === 'string')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Base58_1.Base58.decode(seed)];
                    case 1:
                        seed = _a.sent();
                        _a.label = 2;
                    case 2:
                        nonceBytes = convert_1.int32ToBytes(nonce);
                        resultSeed = new Int8Array();
                        resultSeed = appendBuffer(resultSeed, nonceBytes);
                        resultSeed = appendBuffer(resultSeed, seed);
                        resultSeed = appendBuffer(resultSeed, nonceBytes);
                        return [4 /*yield*/, Base58_1.Base58.encode(AppCrypt_1.AppCrypt.sha256(AppCrypt_1.AppCrypt.sha256(resultSeed)))];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Qora.getAccountAddressFromPublicKey = function (publicKey) {
        return __awaiter(this, void 0, void 0, function () {
            var publicKeyHash, ripEmd160, addressList, versionByte, checkSum;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        publicKeyHash = AppCrypt_1.AppCrypt.sha256(publicKey);
                        ripEmd160 = new RIPEMD160_1.RIPEMD160();
                        publicKeyHash = ripEmd160.digest(publicKeyHash);
                        addressList = new Int8Array(0);
                        versionByte = new Int8Array([Qora.ADDRESS_VERSION]);
                        addressList = appendBuffer(addressList, versionByte);
                        addressList = appendBuffer(addressList, publicKeyHash);
                        checkSum = AppCrypt_1.AppCrypt.sha256(AppCrypt_1.AppCrypt.sha256(addressList));
                        //ADD FIRST 4 BYTES OF CHECKSUM TO ADDRESS
                        addressList = appendBuffer(addressList, new Int8Array([checkSum[0]]));
                        addressList = appendBuffer(addressList, new Int8Array([checkSum[1]]));
                        addressList = appendBuffer(addressList, new Int8Array([checkSum[2]]));
                        addressList = appendBuffer(addressList, new Int8Array([checkSum[3]]));
                        return [4 /*yield*/, Base58_1.Base58.encode(addressList)];
                    case 1: 
                    //console.log("getAccountAddressFromPublicKey.addressList: ", addressList );
                    //BASE58 ENCODE ADDRESS
                    return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Qora.ADDRESS_VERSION = 15; // 7
    return Qora;
}());
exports.Qora = Qora;
function appendBuffer(buffer1, buffer2) {
    buffer1 = new Int8Array(buffer1);
    buffer2 = new Int8Array(buffer2);
    var tmp = new Int8Array(buffer1.byteLength + buffer2.byteLength);
    tmp.set(buffer1, 0);
    tmp.set(buffer2, buffer1.byteLength);
    return tmp;
}
exports.appendBuffer = appendBuffer;
